import { z } from 'zod';
import { DecimalLikeSchema, IsoDateTimeSchema, NullableUrlSchema, PaginationSchema, UuidSchema } from './common.js';
export const EfectivoMovimientoTipoSchema = z.enum(['ingreso', 'egreso']);
export const EfectivoSaldoSchema = z.object({
    id: UuidSchema,
    saldoActual: DecimalLikeSchema,
    createdAt: IsoDateTimeSchema.nullable(),
});
export const EfectivoMovimientoSchema = z.object({
    id: UuidSchema,
    tipo: EfectivoMovimientoTipoSchema,
    monto: DecimalLikeSchema,
    concepto: z.string().max(300).nullable(),
    comprobanteUrl: NullableUrlSchema,
    sucursalId: UuidSchema.nullable(),
    usuarioId: UuidSchema.nullable(),
    fecha: IsoDateTimeSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreateEfectivoMovimientoRequestSchema = z.object({
    tipo: EfectivoMovimientoTipoSchema,
    monto: DecimalLikeSchema,
    concepto: z.string().max(300).nullable().optional(),
    comprobanteUrl: z.string().url().max(1000).nullable().optional(),
    sucursalId: UuidSchema.nullable().optional(),
    fecha: IsoDateTimeSchema.optional(),
});
export const UpdateEfectivoMovimientoRequestSchema = z.object({
    tipo: EfectivoMovimientoTipoSchema.optional(),
    monto: DecimalLikeSchema.optional(),
    concepto: z.string().max(300).nullable().optional(),
    comprobanteUrl: z.string().url().max(1000).nullable().optional(),
    sucursalId: UuidSchema.nullable().optional(),
    fecha: IsoDateTimeSchema.optional(),
});
export const EfectivoMovimientoListQuerySchema = PaginationSchema.extend({
    tipo: EfectivoMovimientoTipoSchema.optional(),
    from: IsoDateTimeSchema.optional(),
    to: IsoDateTimeSchema.optional(),
});
export const TransferenciaTipoSchema = z.enum([
    'efectivo_a_banco',
    'banco_a_efectivo',
    'caja_a_caja',
    'caja_a_efectivo',
    'efectivo_a_caja',
    'caja_a_banco',
]);
export const TransferenciaSchema = z.object({
    id: UuidSchema,
    tipo: TransferenciaTipoSchema,
    monto: DecimalLikeSchema,
    fecha: IsoDateTimeSchema,
    notas: z.string().max(1000).nullable(),
    usuarioId: UuidSchema.nullable(),
    cajaOrigenId: UuidSchema.nullable(),
    cajaDestinoId: UuidSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
const transferenciaBase = {
    monto: DecimalLikeSchema,
    fecha: IsoDateTimeSchema.optional(),
    notas: z.string().max(1000).nullable().optional(),
};
// caja_a_caja exige as duas cajas; caja↔efectivo exige a caja; tesouraria (efectivo↔banco) usa os singletons globais.
export const CreateTransferenciaRequestSchema = z.discriminatedUnion('tipo', [
    z.object({ tipo: z.literal('efectivo_a_banco'), ...transferenciaBase }),
    z.object({ tipo: z.literal('banco_a_efectivo'), ...transferenciaBase }),
    z.object({
        tipo: z.literal('caja_a_caja'),
        cajaOrigenId: UuidSchema,
        cajaDestinoId: UuidSchema,
        ...transferenciaBase,
    }),
    z.object({ tipo: z.literal('caja_a_efectivo'), cajaId: UuidSchema, ...transferenciaBase }),
    z.object({ tipo: z.literal('efectivo_a_caja'), cajaId: UuidSchema, ...transferenciaBase }),
    z.object({ tipo: z.literal('caja_a_banco'), cajaId: UuidSchema, ...transferenciaBase }),
]);
export const TransferenciaListQuerySchema = PaginationSchema.extend({
    tipo: TransferenciaTipoSchema.optional(),
    from: IsoDateTimeSchema.optional(),
    to: IsoDateTimeSchema.optional(),
});
// ---- Efectivo Central (cofre único) ----
export const EfectivoCentralSchema = z.object({
    saldoActual: DecimalLikeSchema,
    recibidoDelBanco: DecimalLikeSchema,
    recibidoRetornos: DecimalLikeSchema,
    recibidoCheques: DecimalLikeSchema,
});
export const EfectivoCentralMovimientoSchema = z.object({
    id: UuidSchema,
    tipo: z.string().max(50),
    monto: DecimalLikeSchema,
    concepto: z.string().max(300).nullable(),
    usuarioId: UuidSchema.nullable(),
    fecha: IsoDateTimeSchema,
    saldoAnterior: DecimalLikeSchema,
    saldoNuevo: DecimalLikeSchema,
    sucursalId: UuidSchema.nullable(),
    referenciaId: UuidSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const EfectivoCentralMovimientoListQuerySchema = PaginationSchema.extend({
    from: IsoDateTimeSchema.optional(),
    to: IsoDateTimeSchema.optional(),
});
//# sourceMappingURL=efectivo.js.map